module.exports = __webpack_public_path__ + "static/cercazone_sudovest4-cdfdcb0eb79bcb127467bff66676bdd0.jpg";